import { __assign } from "tslib";
import { computeStackTrace, formatUnknownError, getTimeStamp, startAutomaticErrorCollection, } from '@datadog/browser-core';
import { RumEventType } from '../../../rawRumEvent.types';
import { LifeCycleEventType } from '../../lifeCycle';
export function startErrorCollection(lifeCycle, configuration) {
    return doStartErrorCollection(lifeCycle, startAutomaticErrorCollection(configuration));
}
export function doStartErrorCollection(lifeCycle, observable) {
    observable.subscribe(function (error) { return lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, processError(error)); });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, startTime = _a.startTime, customerContext = _a.context, source = _a.source;
            var rawError = computeRawError(error, startTime, source);
            lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, __assign({ customerContext: customerContext,
                savedCommonContext: savedCommonContext }, processError(rawError)));
        },
    };
}
function computeRawError(error, startTime, source) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return __assign({ startTime: startTime, source: source }, formatUnknownError(stackTrace, error, 'Provided'));
}
function processError(error) {
    var rawRumEvent = {
        date: getTimeStamp(error.startTime),
        error: {
            message: error.message,
            resource: error.resource
                ? {
                    method: error.resource.method,
                    status_code: error.resource.statusCode,
                    url: error.resource.url,
                }
                : undefined,
            source: error.source,
            stack: error.stack,
            type: error.type,
        },
        type: RumEventType.ERROR,
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startTime,
    };
}
//# sourceMappingURL=errorCollection.js.map